
export const activeSubscriptionStates = ['ACTIVE', 'FAILING', 'SNOOZED'];

export const inactiveSubscriptionStates = ['EXPIRED', 'FAILED', 'INACTIVE'];
